import { render, staticRenderFns } from "./PriceTypeSlidebar.vue?vue&type=template&id=07f51e01"
import script from "./PriceTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./PriceTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports